import { Switch } from "@babackapp/ui/components/switch";
import { Label } from "@babackapp/ui/components/label";
import { useState } from "react";
import useScannerMode from "@/hooks/use-scanner-mode.ts";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import useTranslation from "@babackapp/translations/use-translation";

export default function ScannerButton() {
  const { data: shop } = useCurrentShopSuspense();
  const [active, setActive] = useState(false);
  const t = useTranslation();

  useScannerMode({ shopId: shop.id, active });

  return (
    <div className="px-6 flex flex-wrap space-x-2 text-left justify-between text-sm font-medium py-2 h-auto text-navigation-foreground gap-2 focus-visible:ring-1 ring-navigation-focus ring-offset-navigation space-between">
      <Label htmlFor="scanner-mode">{t("scannerMode.title")}</Label>
      <Switch
        id="scanner-mode"
        className="data-[state=unchecked]:bg-gray-600"
        checked={active}
        onCheckedChange={setActive}
      />
    </div>
  );
}
